import { withFormik } from 'formik';
import * as Yup from 'yup';
import BankFormTemplate from './bank-form.template';

const ibanSchema = Yup.string()
    .required('وارد کردن شماره شبا الزامی است')
    .length(26, 'فیلد شماره شبا باید دقیقاً 26 کاراکتر با احتساب IR باشد')
    .test('is-valid-iran-iban', 'شماره شبا معتبر نیست', (value) => {
        if (!value) return false;
        return /^IR[0-9]{24}$/.test(value);
    });

const BankFormStep = withFormik({
    mapPropsToValues: () => ({ iban: '', backup_iban: '' }),
    validationSchema: Yup.object().shape({
        iban: ibanSchema,
        backup_iban: ibanSchema.notOneOf(
            [Yup.ref('iban')],
            'شماره شبای پشتیبان باید با شماره شبای اصلی متفاوت باشد',
        ),
    }),
    validateOnMount: true,
    handleSubmit: (values, { setSubmitting }) => {},
})(BankFormTemplate);

export default BankFormStep;
